/* istanbul ignore next */
const getLocationPath = (url = '') => {
    const locationPath = url.includes('undefined') ? '' : url;
    const seoUrl = locationPath === '/' ? '/home' : locationPath;
    return seoUrl;
};

/**
 * This method returns media type from the IRIS data for a device type
 *
 * @param {Object} deviceType object holding all the device types
 * @param {Object} mediaType object holding all the media types
 * @return {Object}
 *
 * Usage:
 * getMediaTypeForDeviceType({isMobile: true}, { smallMedia: {}})
 */

export const getMediaTypeForDeviceType = (deviceType, mediaType) => {
    const { isDesktop, isMobile, isTablet } = deviceType;
    const { media, smallMedia, mediumMedia } = mediaType;
    let selectedMedia = {};

    if (isDesktop) {
        selectedMedia = media;
    } else if (isMobile) {
        selectedMedia = smallMedia || media;
    } else if (isTablet) {
        selectedMedia = mediumMedia || media;
    }
    return selectedMedia || {};
};

export const convertToKlarnaUnits = (purchaseAmount) => {
    if (!purchaseAmount) {
        return 0;
    }
    return parseInt((purchaseAmount * 100).toFixed(2), 10) || purchaseAmount;
};

let isEventTriggered = false;
/* istanbul ignore next */
export const registerEventListeners = (triggerAnalyticsEvent) => {
    if (isEventTriggered) return;
    const MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type !== 'childList' || !mutation.target) {
                return;
            }
            const isKlarnaNode = mutation?.addedNodes || [];
            isKlarnaNode.forEach((node) => {
                if (
                    node.tagName === 'IFRAME' &&
                    node.className === 'klarna-upstream-interstitial-frame'
                ) {
                    triggerAnalyticsEvent();
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
    });

    isEventTriggered = true;
};

export default getLocationPath;
